import Utils from '../util/Utils.jsx';
import { updateOfflineProgress } from './db.js';
import { activitySetProgress } from '../context/activity.js';

export const setProgress = (dispatch, datasetId, allowOffline, progressData) => {
	const isOnline = Utils.isOnline();
	if (isOnline) {
		const postData = Object.assign({ dataset: datasetId }, progressData);
		Utils.ajax('setProgress', postData, dispatch, result => {
			dispatch(activitySetProgress(progressData));

			if (allowOffline) {
				updateOfflineProgress(datasetId, progressData, isOnline);
			}
		});
	} else if (allowOffline) {
		updateOfflineProgress(datasetId, progressData, isOnline, progressData => {
			dispatch(activitySetProgress(progressData));
		});
	}
};
